module.exports = __webpack_public_path__ + "static/img/icon-head-qr.2f0dc66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/head/icon-head-qr.jpg
// module id = EQU8
// module chunks = 1